<template>
  <Modal v-if="item" :show="true" clickaway @close="hide">
    <Card :title="item.name" theme="flat" class="upsell" :thumbnail="item.image">
      <template v-if="icon" #header>
        <FontAwesomeIcon v-bind="icon" size="4x" />
      </template>
      <template #default>
        <div v-if="item.description" class="upsell__description" v-html="item.description"></div>
        <a v-if="item.link" :href="item.link" class="upsell__read-more" target="_blank">{{ $t('readMore') }}...</a>
        <hr />
        <div class="upsell__price">
          <div class="row">
            <span class="upsell__price-prefix">{{ prefix }} </span>
            <span v-if="price" class="upsell__price-value">{{ price }}</span>
            <span class="upsell__price-suffix">{{ suffix }} </span>
          </div>
          <div v-if="price" class="upsell__price-vat">{{ $t('excludingVat') }}</div>
        </div>
      </template>
      <template #footer>
        <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="hide" />
        <ButtonComponent
          :label="item.actionLabel || $t('readMore')"
          :icon="['fal', 'angle-right']"
          theme="primary"
          v-bind="action.props"
          v-on="action.listeners"
        />
      </template>
    </Card>
  </Modal>
</template>

<script>
import { ModalComponent as Modal } from 'vue-elder-modal'
import Card from '@/components/Card'

import { IconBinding } from '@/utils'
import Items from './items'
import Bus from '@/bus'
import { Currency } from '@/filters'

export default {
  data() {
    return {
      id: null,
    }
  },
  computed: {
    item() {
      return Items.find(item => item.id === this.id)
    },
    icon() {
      if (!this.item || !this.item.icon || this.item.image) return
      return IconBinding(this.item.icon)
    },
    price() {
      if (!this.item.price || !this.item.price.value) return
      return Currency(this.item.price.value)
    },
    action() {
      if (!this.item) return { props: {}, listeners: {} }
      if (this.item.action) return { props: { tag: 'a', href: this.item.action, target: '_blank' }, listeners: {} }

      return {
        props: {},
        listeners: {
          click: () => {
            this.chat()
            this.hide()
          },
        },
      }
    },
    prefix() {
      if (!this.item) return
      let type = this.item.price && this.item.price.type
      switch (type) {
        case 'from':
        case 'fromMonthly':
          return this.$t('priceFrom') + ':'
        case 'individual':
          return this.$t('priceOnRequest')
        case 'monthly':
          return this.$t('pricePerMonth')
        default:
          return
      }
    },
    suffix() {
      if (!this.item) return
      let type = this.item.price && this.item.price.type
      switch (type) {
        case 'fromMonthly':
          return ' / ' + this.$t('multiplicatorMonthly')
        default:
          return
      }
    },
  },
  methods: {
    hide() {
      this.id = null
    },
    chat() {
      Bus.$emit('chat', this.$t('upsaleRequestTemplate', [this.item.name]))
    },
  },
  created() {
    Bus.$on('upsell:show', id => (this.id = id))
    Bus.$on('upsell:hide', () => this.hide())
  },
  components: {
    Modal,
    Card,
  },
}
</script>

<style lang="scss">
.upsell {
  max-width: 400px;

  .card__footer-content {
    justify-content: center;
  }

  hr {
    margin: 1em 0;
  }

  &__read-more {
    display: inline-block;
    margin-top: 5px;
  }

  &__description {
  }

  &__price {
    text-align: right;

    &-value {
      font-size: 1.5em;
      color: var(--primary);
      font-weight: bold;
      line-height: 1;
    }

    &-prefix,
    &-suffix {
      font-weight: bold;
      color: initial;
    }

    &-prefix {
      margin-right: auto;
    }

    &-suffix {
      margin-left: 5px;
    }

    &-vat {
      opacity: 0.5;
    }
  }
}
</style>
